import api from '../../../_services/api';

const mode = process.env.REACT_APP_MODE || 'development';

export function getInstallments(customer_uuid,amount,bin,checkout_uuid,channel) {
  return api.get(`/api/options-installment?customer_uuid=${customer_uuid}&amount=${amount}&bin=${bin}&installment_config=${mode}&checkout_uuid=${checkout_uuid}&channel=${channel}`)
}